import * as api from '../api';

export const login = (token, user) => {
  return {
    type: 'AUTH_LOGIN',
    payload: { token, user }
  }
}

export const resetAuth = () => {
  return {
    type: 'AUTH_RESET'
  }
}

export const updateAccount = (user) => {
  return {
    type: 'AUTH_UPDATE_ACCOUNT',
    payload: user
  }
}

// Thunks
export function getAccountAPI() {
  return function(dispatch) {
    return api.getAccount().then(
      (user) => dispatch(updateAccount(user)),
      (error) => console.warn(error)
    );
  }
}
